// extracted by mini-css-extract-plugin
export default {"popover":"popover--7SsX","header":"header--JdOu","content":"content--Z884","footer":"footer--AWnj"};